module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-down-right-b9c7123e.svg";